<template>
  <v-container
    style="background-color:rgb(243, 243, 243) !important;width:105%;margin-left:-10px;padding:0 0px 0px 0px !important;"
  >
    <div class="pt-4">
      <v-row class="mb-1" justify="space-between" no-gutters style="padding-top:15px">
        <v-col>
          <v-dialog
            ref="dateDialog"
            v-model="dateModal"
            :return-value.sync="dateRange"
            persistent
            width="280px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                style="margin-top:20px;width:90%;margin:0px auto"
                dense
                v-model="dateRangeText"
                label="Click to select date range"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                @click="dateRange = []"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateRange"
              min="2019-01-01"
              :max="new Date().toISOString().substr(0, 10)"
              scrollable
              range
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateModal = false">Cancel</v-btn>
              <v-btn text color="primary" @click="fetchData()">GENERATE</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row style="margin-bottom:40px;">
        <v-col lg="6">
          <v-card :loading="currentlyLoading.users" class="report-card" id="left">
            <v-icon disabled color="#48bb78" class="report-card-icon">mdi-chart-line</v-icon>
            <v-card-title
              v-if="totalUsers <= 999"
              class="report-card-data"
              @click="totalUserChart = true"
            >
              {{ totalUsers }}
              <span class="report-card-data-unit" style="visibility:hidden;">MB</span>
            </v-card-title>
            <v-card-title
              v-if="totalUsers > 999"
              class="report-card-data"
              @click="totalUserChart = true"
            >
              {{ parseFloat(totalUsers / 1000).toFixed(1) }}
              <span class="report-card-data-unit">K</span>
            </v-card-title>
            <v-card-title class="fs-14 py-1 pl-3 report-card-label">
              <span
                class="pr-1 fw-500 text-uppercase"
                style="color:#48bb78;font-size:3.7vw;"
              >Total Users</span>
              <v-tooltip bottom max-width="207" max-height="57">
                <template v-slot:activator="{ on }">
                  <v-icon class="help-icon" v-on="on">mdi-help</v-icon>
                </template>
                <span>Total Number of Wifi Users seen in the Range Selected</span>
              </v-tooltip>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col lg="6">
          <v-card :loading="currentlyLoading.data" class="report-card" id="right">
            <v-icon disabled color="#214294" class="report-card-icon">mdi-chart-line</v-icon>
            <v-card-title
              v-if="totalDataUsed >= 0.1 && totalDataUsed < 99"
              class="report-card-data"
            >
              {{ roundTo(totalDataUsed, 1) }}
              <span class="report-card-data-unit">GB</span>
            </v-card-title>
            <v-card-title
              v-if="totalDataUsed >= 0.1 && totalDataUsed >= 99"
              class="report-card-data"
            >
              {{ roundTo(totalDataUsed, 0) }}
              <span class="report-card-data-unit">GB</span>
            </v-card-title>
            <v-card-title v-if="totalDataUsed < 0.1" class="report-card-data">
              {{ parseInt(totalDataUsed * 1024) }}
              <span class="report-card-data-unit">MB</span>
            </v-card-title>
            <v-card-title class="fs-14 py-1 pl-3 report-card-label">
              <span
                class="pr-1 fw-500 text-uppercase"
                style="color:#214294;font-size:3.7vw;"
              >Data Used</span>
              <v-tooltip bottom max-width="207" max-height="57">
                <template v-slot:activator="{ on }">
                  <v-icon class="help-icon" v-on="on">mdi-help</v-icon>
                </template>
                <span>Total Data Consumed by Wifi Users in the Range Selected</span>
              </v-tooltip>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-data-table
      :loading="currentlyLoading.report"
      loading-text="Fetching Report"
      :headers="headers"
      :items="endUserDataArray"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="mkey"
      mobile-breakpoint
      disable-pagination
      :hide-default-footer="true"
      v-bind:style="{
        'padding-bottom': endUserDataArray.length > 0 ? '20px' : '0px',
      }"
      :must-sort="true"
      sort-by="date"
      :sort-desc="true"
    >
      <template v-slot:top>
        <v-menu transition="slide-y-transition" bottom offset-y>
          <template v-slot:activator="{ on }" color="white">
            <v-btn
              text
              color="black"
              style="position:absolute;right:0;height:40px;width:40px;background-color:transparent !important;border-radius:0px !important;overflow:hidden;"
              v-on="on"
              icon
              :disabled="endUserDataArray.length == 0"
            >
              <v-icon color="white">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list color="#fffaf5">
            <v-list-item :disabled="nonPremium()" dense @click="exportData()">
              <v-list-item-content>
                <v-list-item-title>
                  <span :v-if="nonPremium()">
                    <img src="~/img/locked.svg" style="width:25px; height:25px;" />
                  </span>
                  <span
                    class="fs-12 text-capitalize warm-grey"
                    style="padding-bottom:10px"
                  >Export All Data</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.status="{ item }">
        <v-icon
          dense
          x-small
          v-if="onlineUsers[item.mobile] != null"
          color="green"
          style="margin-left:5px;"
        >mdi-checkbox-blank-circle</v-icon>
        <v-icon
          dense
          x-small
          v-if="onlineUsers[item.mobile] == null"
          color="gray"
          style="margin-left:5px;"
        >mdi-circle</v-icon>
      </template>
      <template v-slot:item.logout="{ item }">
        <v-btn
          x-small
          text
          color="black"
          :disabled="onlineUsers[item.mobile] == null"
          v-bind:style="{
            'text-transform':'capitalize',
            'color': onlineUsers[item.mobile] == null ? 'gray': 'red !important',
            'min-width': '22px',
            'padding': '0px'
          }"
          @click="logoutUser(onlineUsers[item.mobile], item.mobile)"
        >
          <img
            v-if="onlineUsers[item.mobile] == null"
            src="~/img/icons/logout_disabled.svg"
            style="height:20px;float:right;margin-left:10px;padding: 0px 5px;color:black !important"
          />
          <img
            v-if="onlineUsers[item.mobile] != null"
            src="~/img/icons/logout.svg"
            style="height:20px;float:right;margin-left:10px;padding: 0px 5px;color:black !important"
          />
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="ShowItemDetails(item)">mdi-chevron-right</v-icon>
      </template>
    </v-data-table>
    <div v-if="totalUserChart == true">
      <v-card class="mx-auto" max-width="400">
        <v-icon @click="totalUserChart = false">mdi-close</v-icon>
      </v-card>
    </div>
    <div v-if="totalDataChart == true">
      <v-card class="mx-auto" max-width="400">
        <v-icon @click="totalDataChart = false">mdi-close</v-icon>
      </v-card>
    </div>
    <v-dialog
      class="pl-0"
      v-model="showItemDetails"
      style="width:100%;padding-left:0px !important;margin: 4px !important;"
    >
      <v-card dark>
        <v-card-text style="padding:0px 5px 5px 5px">
          <v-skeleton-loader
            v-if="Array.isArray(itemDetails) && itemDetails.length == 0"
            style="border-radius:0px"
            ref="skeleton"
            :boilerplate="false"
            :type="'list-item-three-line'"
            :tile="false"
            class="mx-auto"
          ></v-skeleton-loader>
          <v-simple-table dense v-if="Array.isArray(itemDetails) && itemDetails.length >= 1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left"
                    style="font-size:10px;padding-left:5px;padding-right:0px"
                  >MAC ID</th>
                  <th
                    class="text-left"
                    style="font-size:12px;padding-left:5px;padding-right:0px"
                  >Login Time</th>
                  <th
                    class="text-left"
                    style="font-size:12px;padding-left:5px;padding-right:0px"
                  >Logout Time</th>
                  <th
                    class="text-left"
                    style="font-size:12px;padding-left:5px;padding-right:5px"
                  >Data Used(Mb)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, $index) in itemDetails" :key="'detailRow' + $index">
                    <td v-if="item" style="font-size:10px;padding-left:5px;padding-right:0px">{{ item.macId }}</td>
                    <td v-if="item"
                      style="font-size:10px;padding-left:5px;padding-right:0px"
                    >{{ item.startTimestamp }}</td>
                    <td v-if="item"
                      style="font-size:10px;padding-left:5px;padding-right:0px"
                    >{{ item.endTimestamp }}</td>
                    <td v-if="item" style="font-size:10px;padding-left:5px;padding-right:5px">
                      {{
                      parseInt(formatData(item.dataUpload + item.dataDownload))
                      }}
                    </td>
                </tr>
              </tbody>
              <div
                v-if="nonPremium()"
                style="border-radius:5px;border:solid 1px red;margin-left:-5px;width:100%;background-color:rgba(255,255,255,0.9);display:block;height:-webkit-fill-available;position:absolute;top:0px;text-align:center;z-index:999999;"
              >
                <div style="display:block;position:relative;top:25px">
                  <img style="width:50px;height:50px;" src="~/img/locked.svg" />
                  <span
                    style="display:block;font-weight:bold;font-size:16px;color:#000"
                  >Premium Feature</span>
                </div>
              </div>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="showItemDetails = false">Close</v-btn>
          <v-btn color="green darken-1" text @click="exportDetailData()">Export Report</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "./../../plugins/axios";
import helper from "./../../utils/helper";

export default {
  props: ["storeData", "selectedLocation"],
  data: function() {
    return {
      expanded: [],
      singleExpand: null,
      showItemDetails: false,
      headers: [
        { text: "Status", value: "status", sortable: false, align: "center" },
        { text: "Mobile", value: "mobile", align: "center" },
        { text: "Date", value: "date", align: "center" },
        { text: "Data Used", value: "data", align: "center" },
        { text: "", value: "logout", sortable: false, align: "center" },
        { text: "", value: "actions", sortable: false, align: "center" }
        //{ text: "", value: "data-table-expand" }
      ],
      onlineUsers: {},
      totalUsers: 0,
      totalDataUsed: 0,
      endUserDataArray: [],
      chartArray: [],
      totalUserChart: false,
      totalDataChart: false,

      dateModal: false,
      dateRange: [null, null],
      startDateString: "",
      endDateString: "",
      itemDetails: [],
      currentlyLoading: {
        data: false,
        users: false,
        report: false
      },
      sortable: "date"
    };
  },
  computed: {
    dateRangeText() {
      var txt = this.dateRange.join(" to ");
      if (txt == " to ") return null;
      return this.dateRange.join(" to ");
    }
  },
  methods: {
    nonPremium: function() {
      if (
        this.selectedLocation.subscription &&
        this.selectedLocation.subscription.active == true
      )
        return false;
      return true;
    },
    FormatData: function(data) {
      if (!data)
        //0
        return [0, "MB"];
      else {
        if (data >= 0 && data <= 999) {
          //1
          return [parseInt(data), "MB"];
        } else {
          if (data > 999 && data <= 9999) {
            //2
            return [parseInt((data / 1000).toFixed(1)), "GB"];
          } else {
            if (data > 9999 && data <= 99999) {
              //3
              return [parseInt((data / 1000).toFixed(1)), "GB"];
            } else {
              if (data >= 99999 && data <= 999999) {
                //4
                if (
                  (data / 1000).toFixed(1) -
                    parseInt((data / 1000).toFixed(1)) <=
                  0.5
                )
                  return [parseInt(Math.floor((data / 1000).toFixed(1))), "GB"];
                else
                  return [parseInt(Math.ceil((data / 1000).toFixed(1))), "GB"];
              } else {
                return [Math.ceil((data / (1000 * 1000)).toFixed(1)), "TB"];
              }
            }
          }
        }
      }
    },
    roundTo: function(n, digits) {
      if (digits === undefined) {
        digits = 0;
      }

      var multiplicator = Math.pow(10, digits);
      n = parseFloat((n * multiplicator).toFixed(11));
      var test = Math.round(n) / multiplicator;
      return +test.toFixed(digits);
    },
    formatData: function(val) {
      return Math.floor((1000 * val) / (1024 * 1024)) / 1000;
    },
    logoutUser: function(mobile, mkey) {
      axios
        .post(
          "/Admin/LogoutUser?i2e1-admin-token=" +
            helper.getCookie("token") +
            "&i2e1-admin-view-token=" +
            helper.getCookie("token"),
          {
            nasids: [this.selectedLocation.nasid],
            mkey: mkey,
            mobile: mobile
          }
        )
        .then(() => {
          //console.log(response);
        });
    },
    fetchDetails: function(data) {
      //console.log("fetching details of ", data);
      axios
        .post(
          "/Admin/GetDetailedReport?" +
            "startTime=" +
            this.dateRange[0] +
            "%200:0:0" +
            "&endTime=" +
            this.dateRange[1] +
            "%2023:59:59" +
            "&i2e1-admin-token=" +
            helper.getCookie("token") +
            "&i2e1-admin-view-token=" +
            helper.getCookie("token"),
          {
            nasids: [this.selectedLocation.nasid],
            mkey: data.mkey,
            mobile: data.mobile
          }
        )
        .then(response => {
          var details = [];
          response.data.data.forEach((d) => {
            var s = d.sessionStart.split('T');
            var e = d.sessionEnd.split('T');
            var sDate = s[0].substring(0, 10).split("-");
            var eDate = e[0].substring(0, 10).split("-");
            d.startTimestamp = `${sDate[2].substring(0,2)}/${sDate[1]}/${sDate[0]} - ${s[1].substring(0, 8)}`;
            d.endTimestamp = `${eDate[2].substring(0,2)}/${eDate[1]}/${eDate[0]} - ${e[1].substring(0, 8)}`;
            details.push(d);
          });
          for (var x in this.endUserDataArray) {
            //console.log("===-->>", this.endUserDataArray[x], data);
            if (data.mobile == this.endUserDataArray[x].mobile)
              this.itemDetails = details;
          }
          if (this.nonPremium())
            this.itemDetails = [
              {
                dataUpload: 1439962,
                dataDownload: 2827667,
                sessionStart: "04/06/2020 11:41:57",
                sessionEnd: "04/06/2020 11:55:23",
                macId: "70:BB:E9:38:75:8A"
              },
              {
                dataUpload: 1439962,
                dataDownload: 2827667,
                sessionStart: "04/06/2020 11:41:57",
                sessionEnd: "04/06/2020 11:55:23",
                macId: "70:BB:E9:38:75:8A"
              },
              {
                dataUpload: 1439962,
                dataDownload: 2827667,
                sessionStart: "04/06/2020 11:41:57",
                sessionEnd: "04/06/2020 11:55:23",
                macId: "70:BB:E9:38:75:8A"
              },
              {
                dataUpload: 1439962,
                dataDownload: 2827667,
                sessionStart: "04/06/2020 11:41:57",
                sessionEnd: "04/06/2020 11:55:23",
                macId: "70:BB:E9:38:75:8A"
              },
              {
                dataUpload: 1439962,
                dataDownload: 2827667,
                sessionStart: "04/06/2020 11:41:57",
                sessionEnd: "04/06/2020 11:55:23",
                macId: "70:BB:E9:38:75:8A"
              }
            ];
        });
    },
    ShowItemDetails: function(item) {
      //console.log("show details of", item);
      this.itemDetails = [null, null];
      this.showItemDetails = true;
      this.fetchDetails(item);
    },
    datesInvalid: function() {
      if (this.dateRange[0] && this.dateRange[0] != "")
        if (this.dateRange[1] && this.dateRange[1] != "") return false;
        else return true;
      else return true;
    },
    fetchData: function() {
      this.endUserDataArray = [];
      this.currentlyLoading = {
        data: "#214294",
        users: "#48bb77",
        report: "#f06b68"
      };
      var dtRange = this.dateRange;
      if (this.datesInvalid()) return false;
      this.dateModal = false;
      axios
        .get(
          "/wiom/GetDataUsage?nasid=" +
            this.selectedLocation.nasid +
            "&startTime=" +
            this.dateRange[0] +
            "%200:0:0" +
            "&endTime=" +
            this.dateRange[1] +
            "%2023:59:59" +
            "&i2e1-admin-token=" +
            helper.getCookie("token") +
            "&i2e1-admin-view-token=" +
            helper.getCookie("token")
        )
        .then(response => {
          //console.log("get data usage");
          if (
            response.data &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            var data = response.data.data;
            this.endUserDataArray = [];
            data.forEach(user => {
              this.totalDataUsed = (
                parseFloat(this.totalDataUsed) +
                (parseFloat(user.dataUpload) + parseFloat(user.dataDownload)) /
                  (1024 * 1024 * 1024)
              ).toFixed(2);
              user.details = [];
              user.data = `${parseInt(
                this.formatData(user.dataDownload + user.dataUpload)
              )}MB`;
              var dateParts = user.sessionEnd.substring(0, 10).split("-");
              user.date = `${dateParts[2].substring(0,2)}/${dateParts[1]}/${dateParts[0]}`;
              this.endUserDataArray.push(user);
            });
            this.totalUsers = data.length;
            this.endUserDataArray = data;
            this.dateRange = dtRange;
          } else {
            this.dateRange = dtRange;
          }
          this.currentlyLoading = {
            data: false,
            users: false,
            report: false
          };
        });
    },
    reset: function() {
      //console.log("reset");
      this.totalUsers = 0;
      this.totalDataUsed = 0.0;
      this.endUserDataArray = [];
      this.totalUserChart = false;
      this.totalDataChart = false;

      this.dateModal = false;
      this.startDateModal = false;
      this.endDateModal = false;
      /*this.dateRange = [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10)
      ];*/
      this.startDateString = new Date().toISOString().substr(0, 10);
      this.endDateString = new Date().toISOString().substr(0, 10);
    },
    exportData: function() {
      if (this.endUserDataArray == null || this.endUserDataArray.length < 1)
        return 0;
      var convertToMB = function(val) {
        return Math.floor((1000 * val) / (1024 * 1024)) / 1000;
      };
      var content = ["Mobile,Date,Data Used(Mb)"];
      this.endUserDataArray.forEach(obj => {
        /*console.log(obj);
        var dd = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
        dd.setDate(dd.getDate() + parseInt(obj.day));
        dd = dd.toISOString().substring(0, 10);*/
        content.push(
          obj.mobile +
            "," +
            obj.sessionEnd.substring(0, 10) +
            "," +
            convertToMB(obj.dataUpload + obj.dataDownload)
        );
      });

      var blob = new Blob([content.join("\r\n")], {
        type: "text/csv"
      });
      var filename = "report.csv";
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    },
    exportDetailData: function() {
      if (this.itemDetails == null || this.itemDetails.length < 1) return 0;
      var content = ["Mac ID,Login Time,Logout Time,Data Used (Mb)"];
      this.itemDetails.forEach(obj => {
        content.push(
          obj.macId +
            "," +
            obj.sessionStart +
            "," +
            obj.sessionEnd +
            "," +
            parseInt(this.formatData(obj.dataUpload + obj.dataDownload))
        );
      });

      var blob = new Blob([content.join("\r\n")], {
        type: "text/csv"
      });
      var filename = `detail_report.csv`;
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    }
  },
  mounted: function() {},
  watch: {
    selectedLocation: function() {
      //console.log("reset");
      this.reset();
    }
  }
};
</script>
